
export class VehicleStatusModel {
    public statusId: string;
    public statusComment: string;
    public supplierId: string;
}
